import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { LegsEintrag } from "../../Api/DcoApi/Admin/AdminClasses2";
import { AdminCard } from "../Controlls/Sonstige/AdminCard";

@Component({
  selector: 'LegsHist',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminCard],
  templateUrl: './LegsHist.html',
  styleUrl: './LegsHist.css'
})

export class LegsHist {
  @Input() Items: LegsEintrag[] = [];

  modal = inject(NgbActiveModal);
}
